<template>
  <div class='lib__form__main' data-cy='identification-component'>
    <div class='lib__form__main__content'>
      <header class='lib__form__main__header'>
        <h2 class='lib__h2'>{{ $t('identification.smartMeter.title') }}</h2>
      </header>
      <ValidationObserver ref='validator' slim>
        <Identification @canContinue='canContinue($event)' @eanCode='eanCode = $event' @eanResult='eanResult = $event'
          @isIdentified='isIdentified = $event' @connectionContract='connectionContract = $event' />
        <IdentificationConfirmation v-if='isIdentified && eanResult' :eanCode='eanCode' :eanResult='eanResult'
          :connectionContract='connectionContract' />
      </ValidationObserver>

    </div>
  </div>
</template>

<script lang='ts'>
import Step from '@/components/steps/Step'
import Identification from '@/components/inputs/SmartMeterConnection/Identification.vue'
import IdentificationConfirmation from '@/components/inputs/SmartMeterConnection/IdentificationConfirmation.vue'
import Component from 'vue-class-component'
import { CheckEanSmartMeterResult, EanConnectionContractResult } from '@/models'
import { State } from 'vuex-class'

@Component({
  name: 'identification-step',
  components: {
    Identification,
    IdentificationConfirmation
  }
})
export default class IdentificationStep extends Step {
  //#region [Data]
  @State('requestId', { namespace: 'smartMeterConnection' })
  public requestId!: string

  public eanCode: string | null = null
  public eanResult: CheckEanSmartMeterResult | null = null
  public isIdentified: boolean | null = null
  public connectionContract: EanConnectionContractResult | null = null
  //#endregion

  //#region [Computed]
  //#endregion

  //#region [Mutation]
  //#endregion

  //#region [Watch]
  //#endregion

  //#region [Method]
  public mounted() {
    this.setIsBack(false)
  }

  public async save(next: boolean, isValid: boolean): Promise<boolean> {

    if (isValid) {
      this.$appInsights.trackEvent('WR_SMC_StepIdentification_Validated', {
        Segment: 'WR_SMC',
        WebRef: this.requestId,
        ZipCode: this.eanResult?.consumptionAddress.zipCode ?? '',
      })
    }
    return next && isValid
  }

  //#endregion
}
</script>